import { IQuantity, Quantity } from "../../../../common/models/quantity.model";

export const generateAccepted = (quantity: IQuantity, actions: any, selectedOrder?: any) => {
  const needsOrderTypeItem = selectedOrder && selectedOrder.isFromCuo === "CUO" && selectedOrder.orderTypeItem === "Specjalne";

  const realizationBtn = needsOrderTypeItem ? {
    key: "check out",
    text: "Nadaj typ pojazdu w rozbiciach",
    iconProps: { iconName: "Warning" },
    disabled: true,
  } : {
    key: "check out",
    text: "Realizuj",
    iconProps: { iconName: "BusSolid" },
    onClick: actions.pushToRealization,
  };

  const cuoSplitsButton = selectedOrder && selectedOrder.isFromCuo === "CUO" ? [{
    key: "cuoSplits",
    text: "Zarządzaj rozbiciami",
    iconProps: { iconName: "BranchMerge" },
    name: "cuoSplits",
    onClick: actions.openCuoSplitsPanel,
  }] : [];

  switch (quantity) {
    case Quantity.NONE:
      return []
    case Quantity.ONE:
      return [
        {
          key: "add",
          text: "Zobacz",
          iconProps: { iconName: "textDocument" },
          onClick: actions.openPanelToSee,
        },
        {
          key: "edit",
          text: "Edytuj",
          iconProps: { iconName: "edit" },
          onClick: actions.openPanel,
        },
        ...cuoSplitsButton,
        realizationBtn,
        {
          key: "delete",
          text: "Anuluj zamówienie",
          iconProps: { iconName: "delete" },
          name: "delete",
          onClick: actions.setOrderCanceled,
        },
      ];
    case Quantity.MANY:
      return [realizationBtn, {
        key: "delete",
        text: "Anuluj zamówienie",
        iconProps: { iconName: "delete" },
        name: "delete",
        onClick: actions.setOrderCanceled,
      },];
  }
};
